import externalLink from '../icons/externalLink.svg'
import greenCheck from '../icons/greenCheck.svg'
import greyHyphen from '../icons/greyHyphen.svg'
import redCross from '../icons/redCross.svg'

export const TD_DROPDOWN_OPEN_CLASS = 'td-dropdown--open'

export function buildLocaleHeaders() {
  const localeRow = document.getElementById('localeHeaderRow')
  localeRow.innerHTML = ''
  window.locales.forEach(locale => {
    const th = document.createElement('th')
    th.textContent = locale
    localeRow.appendChild(th)
  })
}

export function updatePaginationControls(totalCount, currentPage, pageSize) {
  const previousPageButton = document.getElementById('previousPage')
  const nextPageButton = document.getElementById('nextPage')
  const pageInfo = document.getElementById('pageInfo')
  const safePageSize = pageSize > 0 ? pageSize : 1
  const totalPages = totalCount > 0 ? Math.ceil(totalCount / safePageSize) : 1

  pageInfo.textContent = `${currentPage} / ${totalPages}`
  previousPageButton.disabled = currentPage <= 1
  nextPageButton.disabled = currentPage >= totalPages
}

export function getPage({ direction, currentPage, totalCount, pageSize }) {
  const safePageSize = pageSize > 0 ? pageSize : 1
  const totalPages = totalCount > 0 ? Math.ceil(totalCount / safePageSize) : 1

  if (direction === 'previous' && currentPage > 1) {
    return currentPage - 1
  }
  if (direction === 'next' && currentPage < totalPages) {
    return currentPage + 1
  }

  return currentPage
}

export function setLocaleStatusCell({ cell, status, lastSyncedDate, isRedirect, redirectTarget }) {
  const syncedLabel = formatDate(lastSyncedDate) ? `Last Synced Date: ${formatDate(lastSyncedDate)}` : 'Last Synced Date: N/A'

  let iconSrc = greyHyphen
  let iconAlt = '⛔'
  let statusText = 'Translation is outdated'
  let statusClassModifier = 'translation-tooltip__status--outdated'
  let additionalInfo = ''

  // For redirect pages, show special status
  if (isRedirect === 'true') {
    iconSrc = externalLink
    iconAlt = '↗'
    statusText = 'Redirecting page'
    statusClassModifier = 'translation-tooltip__status--redirect'
    if (redirectTarget && redirectTarget !== 'none' && redirectTarget !== 'not specified') {
      additionalInfo = `<div class="translation-tooltip__redirect">Target: ${redirectTarget}</div>`
    }
  } else if (status === 'up-to-date') {
    iconSrc = greenCheck
    iconAlt = '✅'
    statusText = 'Translation is up-to-date'
    statusClassModifier = 'translation-tooltip__status--success'
  } else if (status === 'missing') {
    iconSrc = redCross
    iconAlt = '❌'
    statusText = 'No available translation'
    statusClassModifier = 'translation-tooltip__status--error'
  }

  const wrapper = document.createElement('div')
  wrapper.className = 'translation-tooltip-container'

  // For redirect pages, show text instead of icon
  if (iconSrc === null) {
    const redirectText = document.createElement('span')
    redirectText.textContent = iconAlt
    redirectText.style.fontSize = '16px'
    redirectText.style.color = '#0066CC'
    wrapper.appendChild(redirectText)
  } else {
    const img = document.createElement('img')
    img.src = iconSrc
    img.alt = iconAlt
    wrapper.appendChild(img)
  }

  const tooltip = document.createElement('div')
  tooltip.className = 'translation-tooltip'
  tooltip.innerHTML = `
    <div class="translation-tooltip__status ${statusClassModifier}">${statusText}</div>
    <div class="translation-tooltip__date">${syncedLabel}</div>
    ${additionalInfo}
  `

  wrapper.appendChild(tooltip)
  cell.innerHTML = ''
  cell.appendChild(wrapper)
}

export function formatDate(rawDate) {
  if (!rawDate) {
    return null
  }

  const parsed = new Date(rawDate)
  if (Number.isNaN(parsed.getTime())) {
    // If the backend already sends a formatted string, keep it as-is
    return rawDate
  }

  const month = String(parsed.getMonth() + 1).padStart(2, '0')
  const day = String(parsed.getDate()).padStart(2, '0')
  const year = String(parsed.getFullYear()).slice(-2)

  return `${month}/${day}/${year}`
}

export function getAuthorUrl(path) {
  const { protocol, hostname, port } = window.location
  // AEMaaCS hosts follow <env>-pNNNNNN-eNNNNNNN.adobeaemcloud.com; swap the env prefix for 'author'
  // so this resolves correctly on any environment without code changes.
  const cloudMatch = hostname.match(/^[a-z]+(-p\d+-e\d+\.adobeaemcloud\.com)$/)
  let authorBaseUrl
  if (cloudMatch) {
    authorBaseUrl = `https://author${cloudMatch[1]}`
  } else if (hostname === 'localhost' || hostname === '127.0.0.1') {
    authorBaseUrl = `${protocol}//${hostname}:4502`
  } else {
    authorBaseUrl = `${protocol}//${hostname}${port ? ':' + port : ''}`
  }
  return `${authorBaseUrl}/editor.html${path.startsWith('/') ? path : '/' + path}.html`
}

export function resetSorting() {
  return {
    orderBy: '',
    orderType: '',
  }
}

export function initTranslationDashboardDropdowns() {
  const dropdowns = document.querySelectorAll('.td-dropdown')
  if (!dropdowns || !dropdowns.length) {
    return
  }

  dropdowns.forEach(dropdown => {
    const toggle = dropdown.querySelector('.td-dropdown__toggle')
    const items = dropdown.querySelectorAll('.td-dropdown__item')
    const label = dropdown.querySelector('.td-dropdown__text')
    const select = dropdown.querySelector('select')

    if (!toggle || !items.length || !label) {
      return
    }

    if (!toggle.dataset.tdDropdownInitialized) {
      toggle.dataset.tdDropdownInitialized = '1'

      toggle.addEventListener('click', event => {
        event.stopPropagation()
        if (select && select.disabled) {
          return
        }
        const isOpen = dropdown.classList.contains(TD_DROPDOWN_OPEN_CLASS)

        // Close all dropdowns first so only one can be open
        dropdowns.forEach(other => {
          if (other !== dropdown) {
            other.classList.remove(TD_DROPDOWN_OPEN_CLASS)
          }
        })

        // Toggle current one based on previous state
        if (!isOpen) {
          dropdown.classList.add(TD_DROPDOWN_OPEN_CLASS)
        } else {
          dropdown.classList.remove(TD_DROPDOWN_OPEN_CLASS)
        }
      })
    }

    items.forEach(item => {
      if (!item.dataset.tdDropdownInitialized) {
        item.dataset.tdDropdownInitialized = '1'

        item.addEventListener('click', () => {
          if (select && select.disabled) {
            return
          }
          const value = item.getAttribute('data-value') || item.textContent?.trim() || ''
          label.textContent = item.textContent
          dropdown.classList.remove(TD_DROPDOWN_OPEN_CLASS)

          if (select && value) {
            select.value = value
            const changeEvent = new Event('change', { bubbles: true })
            select.dispatchEvent(changeEvent)
          }
        })
      }
    })
  })

  if (!document.body.dataset.tdDropdownGlobalInitialized) {
    document.body.dataset.tdDropdownGlobalInitialized = '1'

    document.addEventListener('click', () => {
      const openDropdowns = document.querySelectorAll(`.td-dropdown.${TD_DROPDOWN_OPEN_CLASS}`)
      openDropdowns.forEach(openDropdown => {
        openDropdown.classList.remove(TD_DROPDOWN_OPEN_CLASS)
      })
    })
  }
}
